/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/camelcase */
import React, { Component } from 'react';

import { Cookie } from '../../tscapi/utils/cookie';
import { IProduct, IProductEdp } from '../pdp/IProduct';
import EventBus from '../pdp/PdpEventBus';
interface MyState {}

declare global {
    interface Window {
        tfcapi: any;
    }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MyProps {
    SelectedEdpItem: IProductEdp;
    ProductData: IProduct;
}

const clientID = 'tsc';
const options = { autoCalculate: false };

export default class Truefit extends Component<MyProps, MyState> {
    constructor(props) {
        super(props);
    }

    state = {
        styleID: this.props.SelectedEdpItem.StyleDimensionId,
    };

    loadTrueFitLibrary = () => {
        const queryStrings = ['www.tsc.ca', 'origin1.tsc.ca', 'origin1s.tsc.ca'];
        function includes(array, element) {
            return array.indexOf(element) >= 0;
        }
        const pageUrl = window.location.hostname;
        const isProd = includes(queryStrings, pageUrl);
        const environment = isProd ? 'prod' : 'staging';
        /* eslint-disable */
        // prettier-ignore
        (function(r,e,o){
            var w=window,d=document,t,s,x;
            w.tfcapi=t=w.tfcapi||function(){t.q=t.q||[]; t.q.push(arguments);};
            t('init', {storeKey: r, environment: e, ...o});
            x=d.getElementsByTagName('script')[0];
            s=d.createElement('script');
            s.type='text/javascript';s.async=true;
            s.src='https://'+r+'-cdn'+(e==='dev'||e==='staging'?'.'+e:'')+ '.truefitcorp.com/fitrec/'+r+'/js/tf-integration.js';
            x.parentNode.insertBefore(s,x);
          // Don't change anything above this line
          })(clientID,environment,{autoCalculate:false});
        /* eslint-enable */
    };

    calculateAvailableSizes = (selectedEdpData, productData) => {
        //return colon separated list of sizes
        let result = [] as any;
        const allAvailableSizes = [];
        if (productData.Sizes != null) {
            productData.Sizes.forEach((size) => {
                result = productData.Edps.filter(
                    (edps) =>
                        edps.SizeDimensionId == size.DimensionId &&
                        edps.StyleDimensionId == selectedEdpData.StyleDimensionId &&
                        edps.Inventory > 0,
                );
                if (result.length > 0) {
                    allAvailableSizes.push(result[0].Size);
                }
            });
        }
        return allAvailableSizes.join(':');
    };

    configWidget = () => {
        const { SelectedEdpItem } = this.props;
        let userID = null;
        const cookie: Cookie = new Cookie();
        const selectedEdpData = SelectedEdpItem;
        const productEdp = this.props.ProductData;
        const itemNo = SelectedEdpItem.ItemNo.replace(/-/g, '');
        if (
            cookie.UserAccessToken != undefined &&
            cookie.UserAccessToken.Token.length > 0 &&
            cookie.UserAccessToken.Edp > 0
        ) {
            userID = cookie.UserAccessToken.Edp;
        }
        const widgetConfig = {
            products: {},
        };
        if (userID) {
            widgetConfig['userId'] = userID;
            widgetConfig['registered'] = userID ? true : false;
        }
        widgetConfig['locale'] = cookie.Language;
        widgetConfig.products[itemNo] = {
            availableSizes: this.calculateAvailableSizes(selectedEdpData, productEdp),
        };
        if (selectedEdpData.Style) {
            widgetConfig.products[itemNo]['colorId'] = selectedEdpData.Style;
        }
        window.tfcapi('calculate', widgetConfig);
    };

    sendTrueFitCall = () => {
        window.tfcapi(
            'event',
            'tfc-fitrec-product',
            'autoSizeSelect',
            function (context) {
                // truefit recommends a specific size, so fire off an event that pdp will listen for
                const tfSizeEvent = new CustomEvent('tf-sizechanage', {
                    detail: { size: context.size },
                });

                document.dispatchEvent(tfSizeEvent);
            }.bind(this),
        );

        //window.tfcapi('event', 'tfc-fitrec-product', 'error', function(context) {
        //    console.log(context);
        //});

        //window.tfcapi('event', 'tfc-fitrec-product', 'pageload', function(context) {
        //    console.log(context);
        //});

        //window.tfcapi('event', 'tfc-fitrec-product', 'render', function(context) {
        //    console.log(context);
        //});

        //window.tfcapi('event', 'tfc-fitrec-product', 'nostylenouser', function(context) {
        //    console.log('nostylenouser');
        //});
    };

    componentDidMount() {
        this.loadTrueFitLibrary();
        this.configWidget();
        this.sendTrueFitCall();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.SelectedEdpItem?.StyleDimensionId !== this.props.SelectedEdpItem?.StyleDimensionId) {
            this.configWidget();
        }
    }

    render() {
        const itemNo = this.props.SelectedEdpItem.ItemNo.replace(/-/g, '');
        const selectedEdpData = this.props.SelectedEdpItem;
        return (
            <React.Fragment>
                {selectedEdpData && (
                    <div className="tfc-fitrec-product" data-styleid={itemNo} data-colorid={selectedEdpData.Style} />
                )}
            </React.Fragment>
        );
    }
}
